import { ChevronIcon, colors, font } from '@chegg-ui/theme';
import { Link } from '@chegg-ui/link';
import styled, { css } from 'styled-components';
import { styledSpacing } from './root';
var linkCommonCss = css(["&:visited{color:", ";}&:link,&:visited,&:hover,&:active{text-decoration:none;}"], colors.dark); // Main Styles ---

export var TopLevelNavLink = styled(Link).withConfig({
  componentId: "mwio3m-0"
})(["text-decoration:none;color:", ";position:relative;box-sizing:border-box;font-family:", ";font-weight:", ";font-size:", ";white-space:nowrap;width:100%;line-height:", ";margin:", " 0;", ""], colors.dark, font.family["default"], font.weight.bold, font.size.px16, styledSpacing.px42, styledSpacing.px3, linkCommonCss);
export var AccordionControlWrap = styled.div.withConfig({
  componentId: "mwio3m-1"
})(["display:flex;align-items:flex-start;position:relative;"]);
export var AccordionControlButton = styled.button.withConfig({
  componentId: "mwio3m-2"
})(["display:flex;flex-grow:1;justify-content:space-between;align-items:center;text-decoration:none;color:", ";position:relative;box-sizing:border-box;font-family:", ";font-weight:", ";font-size:", ";white-space:nowrap;padding:0;background:none;border:none;cursor:pointer;", ""], colors.dark, font.family["default"], font.weight.bold, font.size.px16, linkCommonCss);
export var AccordionButtonText = styled.span.withConfig({
  componentId: "mwio3m-3"
})(["flex-grow:1;text-align:left;"]);
export var AccordionButtonChevron = styled(ChevronIcon).withConfig({
  componentId: "mwio3m-4"
})(["padding:", ";"], styledSpacing.px13);
export var AccordionControlLink = styled(Link).withConfig({
  componentId: "mwio3m-5"
})(["flex-grow:1;text-decoration:none;color:", ";position:relative;box-sizing:border-box;font-family:", ";font-weight:", ";font-size:", ";white-space:nowrap;padding:", " 0;", ""], colors.dark, font.family["default"], font.weight.bold, font.size.px16, styledSpacing.px13, linkCommonCss);
export var AccordionContainer = styled.div.withConfig({
  componentId: "mwio3m-6"
})(["display:flex;box-sizing:border-box;justify-content:space-between;align-items:center;font-family:", ";padding:", " 0;"], font.family["default"], styledSpacing.px3);
export var Divider = styled.div.withConfig({
  componentId: "mwio3m-7"
})(["border:1px solid ", ";height:", ";box-sizing:border-box;"], colors.greyLight, styledSpacing.px16);
export var AccordionPanel = styled.div.withConfig({
  componentId: "mwio3m-8"
})(["position:relative;display:", ";"], function (props) {
  return props.isOpen ? 'block' : 'none';
});